import { Link as WaspRouterLink, routes } from 'wasp/client/router';
import { SignupForm } from 'wasp/client/auth';
import { AuthPageLayout } from './AuthPageLayout';

// Match the appearance with LoginPage
// Using hex values for Wasp auth forms (required format)
const authAppearance = {
  colors: {
    brand: '#EC4899', // primary (semantic)
    brandAccent: '#F9A8D4', // primary-300 (semantic)
    submitButtonText: 'white',
    inputBackground: 'white',
    inputBorder: '#F5D0FE', // primary-200 (semantic)
    inputBorderHover: '#F9A8D4', // primary-300 (semantic)
    inputBorderFocus: '#EC4899', // primary (semantic)
    dividerBackground: '#F5D0FE', // primary-200 (semantic)
  },
  borderRadii: {
    inputBorderRadius: '6px',
    buttonBorderRadius: '6px',
  },
};

export function Signup() {
  return (
    <AuthPageLayout>
      <SignupForm
        appearance={authAppearance}
        // Optionally add your logo here
        // logo="/your-logo.png"
        socialLayout="vertical"
        additionalFields={[
          {
            name: 'username',
            label: 'Username',
            type: 'input',
            validations: {
              required: 'Username is required',
            },
          },
        ]}
      />
      <br />
      <span className="text-sm font-medium text-neutral-900 dark:text-neutral-200">
        I already have an account (
        <WaspRouterLink
          to={routes.LoginRoute.to}
          className="underline text-primary-700 hover:text-primary dark:text-primary dark:hover:text-primary-400"
        >
          Go to login
        </WaspRouterLink>
        ).
      </span>
      <br />
    </AuthPageLayout>
  );
}
